import React from 'react'

import { Grid as BaseGrid, styled } from '@mui/material'

export const ResumeWrapper = styled('div')`
  grid-area: resume;
`

export const Grid = styled(({ textAlign, ...props }) => <BaseGrid {...props} />)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  text-align: ${props => props.textAlign || 'initial'};
  width: 100%;
`
